import React from 'react';
// import { Link } from 'react-router-dom';

export default function TopBanner(props) {
    const backgroundImage = props.bgimage ? props.bgimage : "/images/about-us/we-provide-best.jpg"; // Path relative to public folder
    
    return (
        <>
        <div 
            className="top-banner-container" 
            style={{
                backgroundImage: `url(${backgroundImage})`,  // Use dynamic image
                backgroundColor: 'rgba(53, 36, 130, 0.3)',  // Solid color with opacity
                // backgroundColor: 'rgba(36, 18, 76, 0.9)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundBlendMode: 'overlay'  // This blends the background color over the image
            }}
        >
            <div className="top-banner-title">
                {props.title}
            </div>
            <h1 className='hide-title'>{props.title}</h1>
        </div>
        </>
    )
};
